export default {
  bgLogin: '/images/bg-login.png',
  avatar: '/images/avatar.png',
  logo: '/images/logo-clean.png',
  defaultProduct: '/images/item-default.png'
};
